export default __webpack_public_path__ + "static/media/190629_190332_Michael & Kennedy 1 JPEG.eed80084.jpg";